import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useRoutes, useLocation } from "react-router-dom";
import AppRouteCGM from "./config/app-route-cgm.jsx";
import AppRouteCMMS from "./config/app-route-cmms.jsx";
import { DashboardContextProvider, useDashboardContext } from "./contexts/NewDashboardContext";
import { slideToggle } from "./composables/slideToggle.js";
import { AuthProvider } from "./contexts/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// bootstrap
import "bootstrap";

// css
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.css";
import "./scss/styles.scss";

const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient();

function App() {
  const { selectedApp } = useDashboardContext()
  console.log(selectedApp)
  let element = useRoutes(selectedApp=='CGM'?AppRouteCGM:AppRouteCMMS);
  let location = useLocation();

  // on every route change
  React.useEffect(() => {
    var elm = document.querySelector(".app");
    if (elm) {
      elm.classList.remove("app-sidebar-mobile-toggled");
    }
    var elm2 = document.querySelector(".app-top-nav");
    if (elm2 && elm2.style.display === "block") {
      slideToggle(document.querySelector(".app-top-nav"));
    }
  }, [location]);

  return element;
}

root.render(
  <AuthProvider>
    <DashboardContextProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </DashboardContextProvider>
  </AuthProvider>
);
